import React, { useMemo } from 'react'
import { Dispatch } from 'redux'
import { useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'
import StarIcon from '@material-ui/icons/Star'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import { Tooltip } from '@material-ui/core'
import { IUserGroupPreferences } from '../../types/userPreferences'
import {
  saveUserPreference,
  deleteUserPreference,
} from '../../actions/userPreferences'
import { getKeyValueCaseInsensitive } from '../../services/common'
import { checkDefaultAndFieldValuesEquality } from '../../services/userPreferences'
import { StyledIconButton } from './styled'

export interface IDefaultValueAdornment {
  fieldName: string
  fieldValue: any
  fieldError?: string
  dispatch: Dispatch
  userGroupPreferences?: IUserGroupPreferences
}

export const DefaultValueAdornment = ({
  fieldName,
  fieldValue,
  fieldError,
  dispatch,
  userGroupPreferences = {},
}: IDefaultValueAdornment) => {
  const { groupId } = useParams()
  const defaultValue = useMemo(
    () => getKeyValueCaseInsensitive(userGroupPreferences, fieldName),
    [userGroupPreferences, fieldName]
  )
  const isDefault = useMemo(
    () =>
      checkDefaultAndFieldValuesEquality(fieldName, fieldValue, defaultValue),
    [fieldName, fieldValue, defaultValue]
  )
  return isEmpty(fieldValue) || fieldError ? null : (
    <StyledIconButton
      aria-label="save-default-value"
      onClick={() => {
        if (!isDefault) {
          dispatch(
            saveUserPreference(groupId, fieldName, fieldValue, !!defaultValue)
          )
        } else {
          dispatch(deleteUserPreference(groupId, fieldName.toLowerCase()))
        }
      }}
    >
      <Tooltip
        title={
          isDefault
            ? 'This value is set as default for all new Graphics.'
            : 'Set this value as the default for all new Graphics.'
        }
      >
        {isDefault ? (
          <StarIcon color="primary" />
        ) : (
          <StarBorderIcon color="primary" />
        )}
      </Tooltip>
    </StyledIconButton>
  )
}
